window.ttx = window.ttx || {};
ttx.jointQuery = {};

/**
 * 为 model 注册 jointQuery 事件监听
 *
 * 扫描 controls 中 jointQuery 为 true 的字段，注册默认监听器。
 * 业务方可通过 model.on('jointQuery', customHandler) 覆写或扩展：
 *
 *   model.on('jointQuery', (params) => {
 *       // params: { field, label, value, record, row, col }
 *       // 执行具体的联动查询业务逻辑
 *   });
 *
 * @param {object} model    — ViewModel 实例
 * @param {Array}  controls — 控件/列配置数组
 * @returns {Function} cleanup — 调用可解绑监听
 */
ttx.jointQuery.setup = function (model, controls) {
    if (!model || !controls) return function () {};

    const hasJointQuery = controls.some(c => c.jointQuery);
    if (!hasJointQuery) return function () {};

    const handler = function (params) {
        ttx.console.log('[jointQuery] 联动查询触发:', params);
    };

    model.on('jointQuery', handler);

    return function cleanup() {
        model.un?.('jointQuery', handler);
    };
};
